import CodeEditor from "components/CodeEditor";
import { External } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";

import { useNewStackAnalyticsSegmentEvent } from "../../useNewStackAnalyticsSegmentEvent";
import { showNewStackAttachedPolicyPreviewDrawer } from "./PreviewDrawer";
import styles from "./styles.module.css";

type NewStackAttachedPolicyContentProps = {
  policyBody: string;
};

const NewStackAttachedPolicyContent = ({ policyBody }: NewStackAttachedPolicyContentProps) => {
  const trackSegmentEvent = useNewStackAnalyticsSegmentEvent();

  const handleCloseDrawer = () => {
    trackSegmentEvent("Close policy preview");
  };
  const handleOpenDrawer = () => {
    trackSegmentEvent("Open policy preview");
    showNewStackAttachedPolicyPreviewDrawer({
      policyBody,
      onClose: handleCloseDrawer,
    });
  };

  return (
    <Box className={styles.codeEditorWrapper}>
      <ButtonIcon
        className={styles.codeEditorExpandButton}
        icon={External}
        onPress={handleOpenDrawer}
        variant="secondary"
      >
        Preview
      </ButtonIcon>
      <CodeEditor body={policyBody} language="rego" readOnly />
    </Box>
  );
};

export default NewStackAttachedPolicyContent;
